import { RecipeContext } from "@/contexts/RecipeContext";
import clsx from "clsx";
import Step from "components/Step";
import filter from 'lodash/filter';
import React, { useContext, useEffect, useRef } from "react";
import { animateScroll as scroll } from "react-scroll";

let stepNumber;
let stepIndex;
let steps;
let numberOfSteps;

const Method = ({ recipe, isRecipeActive }) => {
  const { method } = recipe;
  stepNumber = 0;
  stepIndex = 0;
  steps = filter(method, { typeHandle: "step" });
  numberOfSteps = steps.length;

  return (
    <div className={clsx("Method", "space-y-8")}>
      {method.map((block, _i) => {
        let component;

        switch (block.typeHandle) {
          case "heading":
            component = <_HeaderBlock block={block} />;
            break;
          case "step":
            component = (
              <_StepBlock
                block={block}
                isRecipeActive={isRecipeActive}
                recipe={recipe}
              />
            );
            break;
          default:
            component = null;
        }

        return (
          <div key={block.id} className="Method__block">
            {component}
          </div>
        );
      })}
    </div>
  );
};

const _HeaderBlock = ({ block }) => {
  stepNumber = 0;

  return (
    <div className={clsx("Method__header", "mb-4")}>
      <h2 className="Method__heading">{block.heading}</h2>
    </div>
  );
};

const _StepBlock = ({ recipe, block, isRecipeActive }) => {
  const { activeStepIndex } = useContext(RecipeContext);

  const ref = useRef(null);

  stepIndex = steps.findIndex((s) => s.id === block.id);
  stepNumber = stepIndex + 1;

  const isLastStep = stepIndex + 1 === numberOfSteps;
  const isActive = activeStepIndex === stepIndex;
  const isCompleted = activeStepIndex > stepIndex;

  useEffect(() => {
    if (isActive && isRecipeActive && ref.current) {
      const { top } = ref.current.getBoundingClientRect();

      // The mobile method can confuse this script, it's still on DOM but off-screen effectively, so it can report 0
      // this quick check just avoids us running this if the value is 0, which means it will still honour whichever
      // version is actually on-screen
      if (top > 0) {
        const distance = top + window.scrollY;

        scroll.scrollTo(distance - 160, {
          smooth: "easeOutQuad",
          duration: 750,
        });
      }
    }
  }, [isActive, isRecipeActive]);

  return (
    <div className={clsx("Method__step")} ref={ref}>
      <Step
        step={block}
        isRecipeActive={isRecipeActive}
        number={stepNumber}
        index={stepIndex}
        isActive={isActive}
        isCompleted={isCompleted}
        isLastStep={isLastStep}
        recipe={recipe}
      />
    </div>
  );
};

export default Method;
